module.exports = __webpack_public_path__ + "img/juntos-por-el-peru.ec1dfc09.png";